import React from 'react'
import TextField from '@mui/material/TextField';

const renderField = ({ input, label, width, type, meta: { asyncValidate, touched, error, warning } }) => {
    let val = (touched && error) || (warning ? true : false)
    let err = '';
    if (typeof error == 'object') {
        err = error.exception
    } else {
        err = error
    }

    return <div className={asyncValidate ? 'async-validating' : ''}>
        <TextField
            label={label}
            name={input.name}
            id={input.name}
            type={type}
            margin="normal"
            helperText={(touched && err)}
            {...input}
            fullWidth={true}
            error={val ? true : false}
            style={{ width: width ? width : '100%', marginTop: width ? 3 : 'auto' }}
            variant="standard"
            onChange={input.onChange}
        />
    </div>

}

export default renderField